import axiosInstance from "./axios.instance";

// api calls for enquries
const API_GET_ENQURIES = async (pageNo, limit,startDate,endDate) => {
  try{
    if (startDate && endDate) {
      const resp = await axiosInstance.get(
        `/enquiry?page=${pageNo}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&isActive=1`
      );
      return resp.data;
    }else{
      const resp = await axiosInstance.get(
        `/enquiry?page=${pageNo}&limit=${limit}&isActive=1`
      );
      return resp.data;
    }
  }catch(err){
    throw err
  }

};

const API_PUT_ENQURY = async (enquiryId, updatedData) => {
  try{
    const resp = await axiosInstance.put(`/enquiry/${enquiryId}`, updatedData);
  return resp.data;
  }catch(err){
    throw err
  }
};

export { API_GET_ENQURIES, API_PUT_ENQURY };
